import { SelectorItem } from "./SelectorItem";

export class TextItem extends SelectorItem {
}
